import Service from './abstract';

const defaultHealthWith = {
    with: 'cardsEnabled'
};

class Cards extends Service {
    constructor () {
        super('cards');
    }

    // getHealth doesnt have a basepath, since its a proxy to the cards service,
    // its done this way since the cards ms is not in the api gateway
    getHealth () {
        return this.get({
            url: '/users/cards/health',
            qs: defaultHealthWith
        });
    }
}

export default new Cards();
